import {Component, Input, inject, OnDestroy, OnInit} from '@angular/core';
import {shareReplay, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {FormBuilder, Validators} from '@angular/forms';
import {PagesRestService} from '../../../../core/cms/services/pages.rest.service';
import {ResponseModel} from '../../../../core/base/response.model';
import {UserAdminRestService} from "../../../../core/user/services/user.admin.rest.service";
import {UserService} from "../../../../core/user/services/user.service";
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {FileUploadComponent} from "../../file-upload/file-upload.component";
import {PageRequest} from "../../../../core/cms/models/page.request.model";
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-page-form',
    templateUrl: './page-form.component.html',
    styleUrl: './page-form.component.scss',
    standalone: false
})
export class PageFormComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$ = new Subject<void>();

  authorities: any[] = [];
  pageForm = this.formBuilder.group({
    id: [''],
    page_title: [''],
    nav_title: ['', Validators.required],
    relative_url: [''],
    content: ['', Validators.required],
    end_date: [''],
    start_date: [''],
    banner_image: [''],
    tile: [''],
    public: [''],
    back_link: [''],
    show_title: [''],
    published: [''],
    authorities: ['']
  })

  @Input() page: any = '';
  bannerImage: string = '';
  tile: string = '';
  pageTitle: string = '';
  success = '';
  error = '';
  private pageRestService = inject(PagesRestService);
  private userService = inject(UserAdminRestService);
  private user = inject(UserService);
  private viewportScroller = inject(ViewportScroller);
  win = window;
  editor = {
    base_url: '/tinymce', // Root for resources
    suffix: '.min',
    min_height: 500, menubar: false,
    toolbar: 'undo redo | visualblocks | blocks | bold italic underline | alignleft aligncenter alignright alignjustify | image link | code | numlist bullist | table | searchreplace | preview' ,
    plugins: 'preview searchreplace visualblocks code advlist lists link image table autoresize',
    content_css: '../styles.css',
    advlist_bullet_styles: 'default disc circle square ',
    toolbar_sticky: true,
    link_class_list: [
      { title: 'None', value: '' },
      { title: 'External Link', value: 'ext_link' },
      { title: 'Button', value: 'btn btn-primary' },
      { title: 'Download Link', value: 'int_down_link' },
      { title: 'Icon Link', value: 'material-symbols-outlined text-medium text-center icon-link' }
    ],
    files_upload_handler: this.files_upload_handler,
    documents_file_types: [
      { mimeType: 'application/pdf', extensions: [ 'pdf' ] },
      { mimeType: 'application/msword', extensions: [ 'doc' ] },
      { mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', extensions: [ 'docx' ] },
      { mimeType: 'text/plain', extensions: [ 'txt' ] }]
  }

  constructor(private formBuilder: FormBuilder,
              private dialog: MatDialog) {
  }

  ngOnInit() {
    this.userService.getAllAuthorities().subscribe((response: any) => {
      const auth = response.return_object;
      let groups: any[] = [];
      let auths: any[] = [];

      groups = auth['user_group'];
      let visAuths = auth['vis_auths'];
      let extAuths = auth['extended_auths'];
      auths = {...visAuths, ...extAuths}

      this.authorities = [
        {label: 'User group', authorities: groups},
        {label: 'Authority', authorities: visAuths}
      ]
    });

    if (this.page !== '') {
      this.pageRestService.pageDetails(this.page).pipe(takeUntil(this.ngUnsubscribe$), shareReplay(1)).subscribe((page: ResponseModel) => {
        if (page.error_code === null) {
          this.pageForm.patchValue(page.return_object)
          this.pageTitle = page.return_object.page_title;
          this.bannerImage = page.return_object.banner_image;
          this.tile = page.return_object.tile;
        }
      })
    }
  }

  pickFile(cb: any, val: any, meta: any) {
    console.log(cb);


    return cb;
  }

  files_upload_handler(blobInfo:any , progress: any) {
    const container ="cms";
    console.log(blobInfo)

    const folder = '';
    const filename = "myfile.pdf";
    const name = (folder ? folder + filename : filename).trim();
    // const ret = this.blobService.uploadFile(this.files[0], name, container, {modified_by: this.getUserDetails(this.data.user)});
    // ret.then(r => {
    //   this.dialogRef.close({error: r.error_code, filename: this.STORAGE +'/'+ container +'/'+ name});
    // return {location: this.STORAGE +'/'+ container +'/'+ name}
    // });

    return {location: "myfile.pdf"}
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  savePage() {
    const data = this.pageForm.value;
    const request = new PageRequest(data);
    request.banner_image = this.bannerImage;
    request.tile = this.tile;

    this.pageRestService.savePage(request).pipe(takeUntil(this.ngUnsubscribe$), shareReplay(1)).subscribe((response: ResponseModel) => {
      this.viewportScroller.scrollToPosition([0, 0]);
      if(response.error_code === null) {
        this.success = 'Page ' + request.page_title + ' succesfully saved';
      } else{
        this.error = 'Something went wrong, please try again later.'
      }
      setTimeout(()=>{
        this.error = '';
        this.success = '';
      }, 30000)
    });
  }

  uploadImage(tile: string, type: string) {
    let fileConfig = new MatDialogConfig();
    fileConfig.autoFocus = true;
    fileConfig.width = '35rem';

    fileConfig.data = {
      user: this.user.getUser(),
      container: 'cms'
    }

    this.dialog.open(FileUploadComponent, fileConfig).afterClosed()
    .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((result: any) => {

      if (!result.error) {
        this.success = 'File ' + result.filename + ' saved';
        console.log(result);
        type === 'banner' ? this.bannerImage = result.filename : '';
        type === 'tile' ? this.tile = result.filename : '';
        this.notify();
      } else {
        this.error = 'There was an error while saving your file, please, try again later.'
      }
    })
  }

  deleteImage(type: string) {
    type === 'banner' ? this.bannerImage = '' : '';
    type === 'tile' ? this.tile = '' : '';
  }

  private notify() {
    setTimeout(() => {
      this.success = '';
      this.error = '';
    }, 30000);
  }
}
